import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../urls";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import  { useNavigate } from 'react-router-dom';
import style from './VerificationAccount.module.css';

export function VerificationAccount() {
    const { t } = useTranslation();
    const { token } = useParams();
    const { id } = useParams();
    const navigate = useNavigate();
    const [isErrorModal, setIsErrorModal] = useState(false);


    useEffect(() => {
        console.log('Component has opened/mounted!');
        const requestOptions = {
            method: "GET"
        };

        fetch(api + "/api/email/verify/"+id+"/"+token, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.message == "Already verified") {
                    if (token.indexOf("?sb=1") >= 0)
                        navigate('/login?sb=1');
                    else
                        navigate('/login');
                }
                if (result.message == "success"){
                    if (token.indexOf("?sb=1") >= 0)
                        navigate('/welcome?sb=1');
                    else
                        navigate('/welcome');
                }
                else
                {
                    setIsErrorModal(true);
                }
            })
            .catch((error) => {
                setIsErrorModal(true);
                console.log("error", error);
            });
    }, [navigate]);

    const handleResendCode = () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
        fetch(api + "/api/email/resend/verify/"+id, requestOptions)
            .then((response) => response.toString())
            .then((result) => {
                navigate('/thank-you');
            })
            .catch((error) => {
                console.error(error);

            });

    };
     return (

        <>
            {isErrorModal && (
            <div className="container-fluid">
                <div className="container">
                    <div className={"signup_section loginbg " + style.loginbg }>
                        <div className="header_sign">
                            <ul>
                                <li>
                                    <Link to="/">
                                        <img
                                            src={window.location.origin + "/images/left_arrow.svg"}
                                        />
                                        <span>{t("text-home")}</span>
                                    </Link>
                                </li>
                                <li className="login">
                                    <span>{t("have-account")}</span>
                                    <Link to="/signup">{t("sign-up")}</Link>
                                </li>
                            </ul>
                        </div>

                        <div className={"more_about login_form"}>
                            <img src={window.location.origin + "/images/sign_logo.svg"} />
                            <h2>{t("text-verification-expiried")}</h2>


                            <div className={style.description}>

                                      <p>{t("span-verification-expiried")}</p>
                                      <p>{t("span-verification-expiried-resend")}</p>
                            </div>
                            <button className={style.resendLinkButton}

                                onClick={(e) => {
                                    handleResendCode();
                                }}
                            >
                                {t("verification-resend-button")}
                            </button>


                            <p>
                                {t("have-account")}
                                <Link to="/signup">{t("sign-up")} </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </>

    );
}